/* USDO ZIP data loader
   Shopify only lets the page template list the first 250 variants of a product.
   Products with more variants get the rest from the product.zipdata template,
   250 at a time, merged into the same .zipavail-data block that the ZIP checker
   and the swatch greying already read. Until a variant's numbers arrive, both
   scripts treat it as unknown, which means it is never greyed out.
   The theme re-renders the product section on every option change, which puts
   back a fresh 250-variant block, so we re-merge whenever a new block appears. */
(function () {
  if (window.USDOZipLoader) return;
  var state = { done: false, loading: false, extra: {} };
  window.USDOZipLoader = state;

  function previewParam() {
    var t = window.Shopify && window.Shopify.theme;
    return (t && t.role && t.role !== "main" && t.id) ? "&preview_theme_id=" + t.id : "";
  }

  function merge() {
    var blocks = document.querySelectorAll(".zipavail-data");
    var changed = false;
    for (var i = 0; i < blocks.length; i++) {
      var d = blocks[i];
      if (d.getAttribute("data-merged") === String(state.done)) continue;
      var data;
      try { data = JSON.parse(d.textContent); } catch (e) { continue; }
      for (var k in state.extra) if (!(k in data) || data[k] == null) data[k] = state.extra[k];
      d.textContent = JSON.stringify(data);
      d.setAttribute("data-merged", String(state.done));
      changed = true;
    }
    return changed;
  }

  function load() {
    var r = document.querySelector(".zipavail");
    if (!r || state.loading || state.done) return;
    var pages = parseInt(r.getAttribute("data-pages"), 10) || 1;
    var url = r.getAttribute("data-url");
    if (pages <= 1 || !url) { state.done = true; return; }
    state.loading = true;
    var reqs = [];
    for (var p = 2; p <= pages; p++) {
      reqs.push(fetch(url + "?view=zipdata&page=" + p + previewParam(), { credentials: "same-origin" })
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; }));
    }
    Promise.all(reqs).then(function (results) {
      results.forEach(function (j) {
        if (!j || !j.data) return;
        for (var k in j.data) if (Object.prototype.hasOwnProperty.call(j.data, k)) state.extra[k] = j.data[k];
      });
      state.loading = false;
      state.done = true;
      merge();
      document.dispatchEvent(new CustomEvent("usdo:zipdata"));
    });
  }

  // Re-merge when the theme swaps in a fresh product section.
  new MutationObserver(function () {
    if (state.done && merge()) document.dispatchEvent(new CustomEvent("usdo:zipdata"));
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", load);
  else load();
})();
